import React from "react"
import logo from '../assets/logo.svg'

//@djavier adapt to your needs
export default function Logo() {
  return (
    <img src={logo} alt="logo"/>
  )
}